"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelTemplate_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var LabelTemplateCategory_1 = require("./LabelTemplateCategory");
var LabelTemplateContent_1 = require("./LabelTemplateContent");
var LabelTemplate_Factory = /** @class */ (function () {
    function LabelTemplate_Factory() {
    }
    LabelTemplate_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CategoryId: model.CategoryId,
            IsActive: model.IsActive,
            IsDefault: model.IsDefault,
            IsSystemTemplate: model.IsSystemTemplate,
            LabelTemplateCategory: LabelTemplateCategory_1.LabelTemplateCategory_Factory.CreateIncoming(model.LabelTemplateCategory),
            LabelTemplateContents: model.LabelTemplateContents && model.LabelTemplateContents.map(function (i) { return LabelTemplateContent_1.LabelTemplateContent_Factory.CreateIncoming(i); }),
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TemplateHeight: model.TemplateHeight,
            TemplateWidth: model.TemplateWidth,
        };
        return result;
    };
    LabelTemplate_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CategoryId: model.CategoryId,
            IsActive: model.IsActive,
            IsDefault: model.IsDefault,
            IsSystemTemplate: model.IsSystemTemplate,
            LabelTemplateCategory: LabelTemplateCategory_1.LabelTemplateCategory_Factory.CreateOutgoing(model.LabelTemplateCategory),
            LabelTemplateContents: model.LabelTemplateContents && model.LabelTemplateContents.map(function (i) { return LabelTemplateContent_1.LabelTemplateContent_Factory.CreateOutgoing(i); }),
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TemplateHeight: model.TemplateHeight,
            TemplateWidth: model.TemplateWidth,
        };
        return result;
    };
    return LabelTemplate_Factory;
}());
exports.LabelTemplate_Factory = LabelTemplate_Factory;
